import server from "../../../../server";
import { getName } from "../../../../utility/utility";


export async function fetchReporteeList(supervisorId: string, pageNumber: number, pageSize: number) {
    const res = await server.employee.getAllReportees(supervisorId, pageNumber, pageSize);
    return res;
}


export function viewMapper(reportees: any[]) {

    return (reportees.map((emp) => (
        {
            id: emp.id,
            active: emp.active,
            name: getName(emp.name.firstName, emp.name?.middleName ?? '', emp.name.lastName),
            designation: emp.designation?.displayName,
            employeeCode: emp.employeeCode,
        }
    )));

}
